












































import { Component } from 'vue-property-decorator';
import { email, required } from 'vuelidate/lib/validators';
import Mixin from '@/mixin';
import { validationMixin } from 'vuelidate';
import authService from '@/services/common/auth.service';
import VMessage from '@/components/items/VMessage.vue';

@Component({
  mixins: [validationMixin],
  name: 'forgot-password',
  components: { VMessage },
  validations: {
    email: { required, email }
  }
})
export default class ForgotPassword extends Mixin {
  public email = '';
  public success = false;
  public responseError = false;

  public async submit(event: Event) {
    event.preventDefault();
    this.$v?.email.$touch();
    if (!(this.$v?.email.$error || this.$v?.email.$invalid)) {
      await authService
        .forgotPassword(this.email)
        .then(() => {
          this.success = true;
          this.responseError = false;
        })
        .catch(() => {
          this.success = false;
          this.responseError = true;
        });
    }
  }
}
